import React from 'react'
import {
  SelectInput,
  SelectInputProps,
  ReferenceInput,
  useTranslate,
  useGetList,
  //   useLocaleState,
  //   required,
} from 'react-admin'
import { COMMON_FIELDS } from '../../providers/localization/constant'

export const ServicesSelectInput: React.FC<SelectInputProps> = ({ ...props }) => {
  const translate = useTranslate()
  const { data, isLoading } = useGetList('mst-services-key', {
    sort: { field: 'create_at', order: 'DESC' },
  })
  //   const [locale] = useLocaleState()
  //   const optionRenderer = useCallback(
  //     (choice): string => `${choice['key']}`,
  //     [],
  //   )
  if (isLoading) {
    return null // Return null while data is loading
  }
  return (
    <ReferenceInput
      label={translate(`${COMMON_FIELDS}.specific_key.label`)}
      source='booking_service_key'
      reference='mst-services-key'
      defaultValue=''
      fullWidth
      sort={{ field: 'create_at', order: 'DESC' }}
    >
      <SelectInput
        isLoading={isLoading}
        margin='none'
        fullWidth
        label={translate(`${COMMON_FIELDS}.specific_key.label`)}
        source='key'
        choices={data}
        optionValue='key'
        optionText='title_th'
        defaultValue=''
        // validate={[required()]}
        {...props}
      />
    </ReferenceInput>
  )
}
